import script from "./BigRadioFlexButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BigRadioFlexButton.vue?vue&type=script&lang=ts&setup=true"

import "./BigRadioFlexButton.vue?vue&type=style&index=0&id=66826a44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66826a44"]])

export default __exports__